import axios from "axios";

export const apiAxios = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

apiAxios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("adminToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);
